import { Reducer } from 'redux'
import { deleteUser, getUserBibInfo } from '@chegg-wt/core/utils/localStorage'
import { Config } from '@chegg-wt/core/config'
import { UserRole } from '@chegg-wt/core/types/auth'
import { ActionTypes } from './constants'
import { UserState } from './types'

export const getInitialState = (Config?) => {
  let migrationInProgress
  if (Config && typeof Config.dataMigrationInProgress !== 'undefined') {
    migrationInProgress = Config.dataMigrationInProgress
  }
  // get localstorage user
  const user = getUserBibInfo()

  const initialState = {
    dataMigrationInProgress: migrationInProgress,
    isLoading: false,
    user: {
      role: '' as UserRole, // not_logged_in === guest user, which we don't know until /token endpoint returns
      paidMember: false,
      subscriptionType: '',
      id: 0,
      first: '',
      last: '',
      email: '',
      username: '',
      encodedId: '',
    },
    oauth: {
      accessKey: '',
      expiresAt: 0,
    },
    projectId: '',
    coupon: null,
    feedbackId: '',
    access_token: '',
    ...user,
  }
  if (typeof migrationInProgress === 'undefined') {
    delete initialState.dataMigrationInProgress
  }
  return initialState
}

export const initialState: UserState = getInitialState(Config)

export const userReducer: Reducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.AUTH_COMPLETE:
      return {
        ...state,
        isLoading: false,
      }
    case ActionTypes.SET_USER:
      return {
        ...state,
        ...action.payload,
      }
    case ActionTypes.LOGIN:
      return {
        ...state,
        isLoading: true,
      }
    case ActionTypes.LOGOUT:
      deleteUser()
      return getInitialState(Config)
    case ActionTypes.DATA_MIGRATION_STATUS:
      return {
        ...state,
        dataMigrationInProgress: action.payload.inProgress,
      }
    case ActionTypes.SET_SELECTED_USER_TYPE:
      if (action.payload && action.payload.memberRole) {
        return {
          ...state,
          selectedUserType: action.payload.memberRole,
        }
      }
      return state
    case ActionTypes.SET_SELECTED_SCHOOL_TYPE:
      if (action.payload && action.payload.schoolType) {
        return {
          ...state,
          selectedSchoolType: action.payload.schoolType,
        }
      }
      return state
    case ActionTypes.SET_PAPER_UPLOADED:
      return {
        ...state,
        hasPaper: true,
      }
    default:
      return state
  }
}

export default userReducer
